import { CategoryService } from './../../../../../../api/category.service';
import { async } from '@angular/core/testing';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentService } from '@app/api/api';
import { AppDrawImageComponent } from './app-draw-image/app-draw-image.component';
import { environment } from '@app/../environments/environment'

@Component({
  selector: 'meu-app-technical-documents',
  templateUrl: './app-technical-documents.component.html',
  styleUrls: ['./app-technical-documents.component.scss']
})
export class AppTechnicalDocumentsComponent implements OnInit {
  @ViewChild('drawimage', { static: false })
  drawimage: AppDrawImageComponent;
  constructor(
    private documentService: DocumentService,
    private route: ActivatedRoute,
  private toastr: ToastrService,
  private changeDetectorRef: ChangeDetectorRef,
  private router: Router,
  private categoryService: CategoryService,

  ) { }
  colEl: any;
  lstShapes: any = [];
  documentId: any;
  documentForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.pattern("^(?!\\s*$).+")]),
    code: new FormControl('', [Validators.required, Validators.pattern("^(?!\\s*$).+")]),
    description: new FormControl(''),
    tags: new FormControl(''),
  });
  document: any = { data: null, shapes: null };
  image: any = null;
  imageServer: any = null;
  catalogId: any = '';
  arrHashtag = [];
  strTag = '';
  lstAllCategories: any;
  lstParentID: any = [];
  lstParentName: any = [];
  labelAllParentsName: any = [];
  ngOnInit() {


    this.colEl = document.querySelector('.div-konva-draw');
    if (this.route.snapshot.params.id != null && this.route.snapshot.params.id !== "" && this.route.snapshot.params.id !== undefined) {
      this.documentId = this.route.snapshot.params.id;
      this.getDocumentById();
    }
    else {
      this.documentId = "00000000-0000-0000-0000-000000000000";
    }
    if (this.route.snapshot.params.catalogId != null && this.route.snapshot.params.catalogId !== "" && this.route.snapshot.params.catalogId !== undefined) {
      this.catalogId = this.route.snapshot.params.catalogId;
      this.getTreeCategories(this.catalogId);
      //this.getDocumentById();
    }

  }
  saveList($event) {
    this.lstShapes = $event;
  }
  saveDocument() {
    this.documentForm.value.name = this.documentForm.value.name.trim();
    this.documentForm.value.code = this.documentForm.value.code.trim();
    const controls = this.documentForm.controls;

    if (this.documentForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      //this.hasFormErrors = true;
      return;
    }
    else {
      let strHashtag = ''
      for (let i = 0; i < this.arrHashtag.length; i++) {
        if (i != this.arrHashtag.length - 1) {
          strHashtag = strHashtag + this.arrHashtag[i] + ','
        }
        else {
          strHashtag = strHashtag + this.arrHashtag[i]
        }
      }
      this.document.data = {
        id: this.documentId,
        name: this.documentForm.value.name,
        code: this.documentForm.value.code,
        description: this.documentForm.value.description,
        image: this.imageServer,
        category_id: this.catalogId,
        tags: strHashtag,
      }
      this.document.shapes = this.lstShapes;
      // for (let i = 0; i < this.lstShapes.length; i++) {
      //   this.document.shapes.push({
      //     data: this.lstShapes[i],
      //     shapeRefs: null,
      //   })
      // }
      //this.document.shapes = this.lstShapes;
      this.documentService.apiDocumentsPost(this.document).subscribe(res => {
        if (res.success) {
          this.documentId = res.data.data.id
          const navigateToList = () => {
            this.router.navigate(['/admin/catalog-management'], { fragment: this.catalogId });
          };

          if (this.image != null) {
            let file: File = this.image;
          //this.documentService.apiDocumentsIdImagePut(res.data.data.id, file).subscribe(resImage => {
          //     if (resImage.success) {
          //       this.toastr.success(
          //         'Lưu dữ liệu thành công.',
          //         ''
          //       );
          //       this.location.replaceState('/admin/catalog-management/' + this.catalogId + "/document/" + res.data.data.id + "/edit");
          //       // 8e6ebaf5-46df-4aeb-b9db-cf7a499ad921/document/b72e0614-a837-4d8e-970d-9d83bf4fd1e3/edit
          //     }
          //   })
          // }
          // else {
          //   this.toastr.success(
          //     'Lưu dữ liệu thành công.',
          //     ''
          //   );
          //   this.location.replaceState('/admin/catalog-management/' + this.catalogId + "/document/" + res.data.data.id + "/edit");

            this.documentService.apiDocumentsIdImagePut(res.data.data.id, file).subscribe(
              resImage => {
                this.toastr.success('Lưu dữ liệu thành công.', '');
                navigateToList();
              },
              err => {
                console.error('Image upload failed', err);
                this.toastr.warning('Lưu dữ liệu thành công (không tải được hình).');
                navigateToList();
              }
            );
          } else {
            this.toastr.success('Lưu dữ liệu thành công.', '');
            navigateToList();
          }
        }

      })
    }
  }
  getDocumentById() {
    var _this = this;
    this.documentService.apiDocumentsIdDataGet(this.documentId).subscribe(res => {
      if (res.success) {
        this.document = res.data
        this.lstShapes = res.data.shapes;
        this.imageServer = res.data.data.image
        this.documentForm.patchValue({
          name: this.document.data.name,
          code: this.document.data.code,
          tags: this.document.data.tags,
          description: this.document.data.description
        })
        if (this.document.data.image != null) {
          this.drawimage.renderImageserver(environment.backendhost + this.document.data.image);
        }
        if (this.lstShapes.length > 0) {
          setTimeout(function () {
            _this.drawimage.getDataServer(_this.lstShapes);
          }, 200);

        }
        if (this.document.data.tags != "") {
          let lstHashtag = this.document.data.tags.split(',');
          for (let i = 0; i < lstHashtag.length; i++) {
            this.arrHashtag.push(lstHashtag[i]);
          }
        }
        //this.drawimage.renderImageserver(environment.backendhost + this.document.image)
      }
    })
  }
  backToCatalogManagement() {
    window.history.back();
  }
  removeTag(index) {
  this.arrHashtag.splice(index, 1);
  this.arrHashtag = this.arrHashtag.slice();
    this.changeDetectorRef.detectChanges();
  }
  onEnterTag(value: string) {
    let newTag = value.replace(/ /g, '');
    newTag = newTag.replace(/#/g, '');
    newTag = newTag.replace(/,/g, '');
    newTag = this.change_alias(newTag);
    if (newTag !== '' && newTag !== undefined && newTag != null) {
      this.strTag = '';
      const checkTagExist = this.arrHashtag
        .map((val) => val)
        .some((el) => el === newTag);
      if (checkTagExist) {
        this.toastr.warning('Hashtag đã tồn tại');
      } else {
  this.arrHashtag.push(newTag);
  this.arrHashtag = this.arrHashtag.slice();
      }
    }
  }
  change_alias(alias) {
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      ' '
    );
    str = str.replace(/ /g, '');
    str = str.trim();
    return str;
  }
  getTreeCategories(id) {
    this.categoryService.apiCategoriesGet().subscribe(r => {
      if (r.success) {
        this.lstAllCategories = r.data;
        let nodeChoosed = this.lstAllCategories.find(x => x.id == id);
        this.lstParentName.push(nodeChoosed.name)
        this.getParentNode(nodeChoosed.parent_id);
        this.lstParentName = this.lstParentName.slice().reverse();
        if (this.lstParentName.length > 3) {
          this.labelAllParentsName.push("...");
          this.labelAllParentsName.push(this.lstParentName[this.lstParentName.length - 3]);
          this.labelAllParentsName.push(this.lstParentName[this.lstParentName.length - 2]);
          this.labelAllParentsName.push(this.lstParentName[this.lstParentName.length - 1]);
        }
        else {
          this.labelAllParentsName = this.lstParentName;
        }
  this.labelAllParentsName = this.labelAllParentsName.slice();
      }
    })
  }
  getParentNode(parentID) {
    for (let index = 0; index < this.lstAllCategories.length; index++) {
      if (this.lstAllCategories[index].id == null && this.lstParentID.findIndex(x => x == null) != -1) {
        continue;
      }
      if (this.lstAllCategories[index].id == parentID) {
        this.lstParentID.push(this.lstAllCategories[index].id);
        this.lstParentName.push(this.lstAllCategories[index].name);
        if (this.lstAllCategories[index].parent_id != "root") {
          this.getParentNode(this.lstAllCategories[index].parent_id)
        }
        else {
          return;
        }
      }
    }
  }
}
